import styled from "styled-components";

import theme from "../../../styles/theme";

// Every dataset on the page loads independently, so each section can fail on its own and needs its
// own way back. Follows the DriverStatsEmpty shape: noun-phrase title, one sentence of why, an
// action that names what it does.
const Wrap = styled.div`
  padding: 28px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.white};
`;

const Text = styled.div`
  font-size: 12px;
  color: ${theme.colors.grey};
  max-width: 420px;
`;

const RetryButton = styled.button`
  margin-top: 10px;
  padding: 10px 18px;
  border: 2px solid ${theme.colors.secondaryDark};
  background: transparent;
  color: ${theme.colors.white};
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${theme.colors.gold};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.gold};
    outline-offset: 2px;
  }
`;

export function LoadFailure({ onRetry }) {
  return (
    <Wrap>
      <Title>Не вдалося завантажити</Title>
      <Text>Схоже, стався тимчасовий збій. Спробуйте ще раз.</Text>
      <RetryButton type="button" onClick={onRetry}>
        Спробувати ще раз
      </RetryButton>
    </Wrap>
  );
}

export default LoadFailure;
